// extracted by mini-css-extract-plugin
module.exports = {"left":"player_left__nsuny","table":"player_table__33Dk5","container":"player_container__bQpzG"};